import RocketIcon from '~domains/partner-application/shared/assets/icons/rocket.svg?react';
import { StatusScreenContent } from '~domains/partner-application/shared/ui/status-screen-content';

import { ScreenHeader, Screen } from '~shared/ui/screen';

export const InProgressScreen = () => {
  return (
    <Screen header={<ScreenHeader singleLogoAlign="left" />}>
      <StatusScreenContent
        icon={<RocketIcon />}
        title={
          <>
            Now <span className="text-skyro-blue">checking</span> your
            application, boss!
          </>
        }
        description={
          <>
            You&#39;ll receive the&nbsp;results by&nbsp;email. We&nbsp;may also
            contact you by&nbsp;phone or&nbsp;email if more&nbsp;documents
            are&nbsp;needed.
          </>
        }
      />
    </Screen>
  );
};
